import moment from 'moment';

export const convertDateToMonthDayYear = (date) => moment.utc(date).format('MMM DD, YYYY');
export const convertDateToDayMonthYear = (date) => moment(date).format('DD-MM-YYYY');

export const convertTime = (time) => moment.utc(time * 1000).format('h:mm a');

export default (date) => {
  return moment(date).format('MM/DD/YY');
};



// WEBPACK FOOTER //
// ./app/lib/formatDate.js